import { AppStoreEnum } from '#lib/enums'
import type { UserStoreState } from '#lib/types'

export const setIsLogged = (isLogged: boolean) => {
  sessionStorage.setItem('isLogged', isLogged.toString())
}

export const removeIsLogged = () => {
  sessionStorage.removeItem('isLogged')
}

export const getUserStorage = () => {
  const data = localStorage.getItem(AppStoreEnum.User)
  if (data && data !== 'undefined') {
    return JSON.parse(data) as UserStoreState
  }

  return null
}
